import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { EnumApprovalState } from "@/models/enum/Enum";
import { useRouter } from "vue-router/composables";
import { $post } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import { ApprovalSearchRequest } from "@/models/approval/ApprovalRequest";
import { ApprovalAttendanceResponse } from "@/models/approval/ApprovalResponse";
import { useApproval } from "@/composable/Approval";

type Banner = {
  text: string;
  color: string;
  index: ApprovalIndex;
};

type ApprovalType = keyof typeof ApprovalType;

type ApprovalIndex = typeof ApprovalIndex[keyof typeof ApprovalIndex];


export default /*#__PURE__*/_defineComponent({
  __name: 'LeaderHome',
  setup(__props) {

const router = useRouter();
const approval = useApproval();

const ApprovalType = {
  Shift: "シフト申請",
  Vacation: "休暇申請",
  Overwork: "残業申請",
  Attendance: "勤務時間変更依頼"
} as const;
const ApprovalIndex = {
  WorkSchedule: 0,
  Vacation: 1,
  Shift: 2,
  Overwork: 3,
  Attendance: 4
} as const;
const routerName = "ApprovalStatus";

const items = ref<Banner[]>([]);

const getBanner = (type: ApprovalType, count = 0): Banner => {
  const text = ApprovalType[type];
  const index = ApprovalIndex[type];

  return count > 0
    ? { text: `承認可能な${text}が${count}件あります。`, color: "red", index }
    : { text: `未承認の${text}はありません。`, color: "blue", index };
};

const getAllCount = async (path: string): Promise<number> => {
  const request: ApprovalSearchRequest = {
    approvals: [
      EnumApprovalState.DURING,
      EnumApprovalState.UNAPPROVAL,
      EnumApprovalState.WAITING
    ]
  };
  const response = await $post<ApprovalAttendanceResponse[]>(path, request);
  return response ? response.length : 0;
};

const getSelfCount = async (path: string): Promise<number> => {
  const request: ApprovalSearchRequest = {
    approvals: [EnumApprovalState.WAITING]
  };
  const response = await $post<ApprovalAttendanceResponse[]>(path, request);
  return response ? response.length : 0;
};

const getShiftItems = async (): Promise<Banner> => {
  const path = Paths.approval.shift.search;
  const response = await getSelfCount(path);
  return getBanner("Shift", response);
};

const getVacationItems = async (): Promise<Banner> => {
  const path = Paths.approval.vacation.search;
  const response = await getSelfCount(path);
  return getBanner("Vacation", response);
};

const getOverworkItems = async (): Promise<Banner> => {
  const path = Paths.approval.overtimeWork.search;
  const response = await getSelfCount(path);
  return getBanner("Overwork", response);
};

const getAttendanceItems = async (): Promise<Banner> => {
  const path = Paths.approval.attendance.search;
  const response = await getSelfCount(path);
  return getBanner("Attendance", response);
};

const getItems = async () => {
  return await Promise.all([
    getShiftItems(),
    getVacationItems(),
    getOverworkItems(),
    getAttendanceItems()
  ]);
};

const onAll = (item: Banner) => {
  approval.setAllCountForm();
  router.push({ name: routerName, params: { value: String(item.index) } });
};

const onOnlyApproval = (item: Banner) => {
  approval.resetForm();
  router.push({ name: routerName, params: { value: String(item.index) } });
};

onMounted(async () => {
  items.value = await getItems();
});

return { __sfc: true,router, approval, ApprovalType, ApprovalIndex, routerName, items, getBanner, getAllCount, getSelfCount, getShiftItems, getVacationItems, getOverworkItems, getAttendanceItems, getItems, onAll, onOnlyApproval }
}

})